import {Selection} from "d3-selection";

import {EDocumentTypes} from "@/components/project/models";
import {ILocalizedText} from "@translate/models";

export const DEFAULT_TEMPERATURE_DECIMAL = 0;
export const DEFAULT_WAVELENGTH_DECIMAL = 0;
export const DEFAULT_ENERGY_DECIMAL = 1;

export enum EACsvExportFormat {
    Json,
    Csv,
}

export enum EProfileDirection {
    Upright,
    UpsideDown,
}

export const DEFAULT_ACSV: IACsvValue = {
    on: false,
    exportFormat: EACsvExportFormat.Json,
    allowSop: true,
    path: "",
    direction: EProfileDirection.Upright,
    region: "user",
    useTabSeparator: false,
    includeLicense: false,
};

export interface IModuleInfo {
    icon: string;
    type: ILocalizedText;
}

interface IExclude {
    id: number;
    type: EDocumentTypes;
}

export interface INameCheckRequest {
    name: string;
    exclude: IExclude;
}

export interface INameCheckResponse {
    name: string;
    isInUse: boolean;
}

export interface IACsvValue {
    on: boolean;
    exportFormat: EACsvExportFormat;
    allowSop: boolean;
    path: string;
    direction: EProfileDirection;
    region: string;
    useTabSeparator: boolean;
    includeLicense: boolean;

    computerName?: string;
    lockedPath?: string;
}

export interface IDragBound {
    top?: number;
    bottom?: number;
    left?: number;
    right?: number;
}

export interface IRowId {
    id?: string;
}

export type IDragHandler = () => Selection<
    HTMLElement,
    string,
    null,
    undefined
>;
